import Banner from "../components/section/banner";
import Counter from "../components/section/counter";
import About from "../components/section/about/v1";
import Team from "../components/section/team/v1";
import FAQ from "../components/section/faq";
import Features from "../components/section/features/v1";
import RecentBlog from "../components/section/recentBlog";
import Treding from "../components/section/treding";
import { Slider, SliderItem } from "../common/slider/Slider";
import data from "../assets/data/banner";

const Home = () => {

  const slider = {
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    centerMode: true,
    centerPadding: "0px",
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };


  return (
    <>
      <Slider {...slider}>
        {data?.map((item, i) => (
          <SliderItem key={i}>
            <Banner key={i} index={i} item={item} />
          </SliderItem>
        ))}
      </Slider>
      <About />
      <Counter />
      <Features />
      <Team />
      <Treding />
      <FAQ />
      <RecentBlog />
    </>
  );
};

export default Home;
